<template>
  <div>
    <Layout
      username="Administrator"
      current-page="Sales"
      link-to-edit="/admin-dashboard/edit-profile"
    >
      <template slot="menuItems">
        <li v-for="{ title, icon, path } in menu" :key="title" class="nav-item">
          <MenuItems :menu-item="title" :icon-menu="icon" :to-where="path" />
        </li>
      </template>
      <template slot="side info">
        <generate-excel :url="generatorUrl" name="epd-admin" />
      </template>
      <template slot="content">
        <div class="jumbotron">
          <div class="my-3">Total: {{ sales.count }}</div>
          <div class="row justify-content-between mb-3">
            <div class="col-4">
              <a-input-search
                v-model="searchQuery"
                placeholder="Search ...."
                :loading="isSearching"
                allow-clear
                @search="onSearch"
              />
            </div>
            <div class="col-3">
              <a-select
                show-search
                allow-clear
                placeholder="Select a person"
                option-filter-prop="children"
                :value="company.name"
                style="width: 100%"
                :filter-option="false"
                :not-found-content="fetchingCompanies ? undefined : null"
                @search="fetchCompanies"
                @change="handleCompanyChange"
              >
                <a-spin
                  v-if="fetchingCompanies"
                  slot="notFoundContent"
                  size="small"
                />
                <a-select-option v-for="item in companies" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <sales-table
            :data="sales.data"
            :pages="sales.pages"
            :loading="loading"
          />
          <div class="my-4">
            <a-pagination
              :current="currentPage"
              :default-current="1"
              :hide-on-single-page="true"
              :default-page-size="50"
              :total="sales.count"
              @change="onPaginate"
            />
          </div>
        </div>
      </template>
    </Layout>
  </div>
</template>

<script>
import Layout from "../../../components/Layout";
import MenuItems from "../../../components/MenuItems";
import { mapGetters } from "vuex";
import SalesTable from "../../../components/Tables/SalesTable.vue";
import GenerateExcel from "../../../components/GenerateSalesExcel";
import http from "../../../helpers/http";
export default {
  name: "Adminreports",
  components: {
    Layout,
    MenuItems,
    SalesTable,
    GenerateExcel,
  },
  data() {
    return {
      currentPage: 1,
      timer: null,
      menu: [
        {
          title: "Dashboard",
          icon: "fa fa-chart-line",
          path: "/admin",
        },
        {
          title: "Add Company",
          icon: "fa fa-plus",
          path: "/admin/companies/new",
        },
        {
          title: "Companies",
          icon: "fa fa-table",
          path: "/admin/companies",
        },
        {
          title: "Sales",
          icon: "fa fa-table",
          path: "/admin/admin-sales",
        },
      ],
      searchQuery: "",
      companyId: null,
      loading: false,
      fetchingCompanies: false,
      companies: [],
      companyValues: [],
      company: {},
    };
  },
  computed: {
    ...mapGetters({
      sales: "admin/getAllSales",
      companies: "admin/getAllCompanies",
    }),
    isSeaching() {
      return (this.searchQuery?.toString().trim().length > 1) & this.loading;
    },
    generatorUrl() {
      const { VUE_APP_SERVER_BASE_URL: BASE_URL } = process.env;
      const { count } = this.sales;
      let url = `${BASE_URL}/sales?page=1&limit=${count}`;
      if (this.searchQuery) {
        url += `&search=${this.searchQuery}`;
      }
      if (this.companyId) {
        url += `&companyId=${this.companyId}`;
      }
      return url;
    },
  },
  watch: {
    // call again the method if the route changes
    $route: "fetchData",
  },
  created() {
    this.fetchData();
  },
  methods: {
    onSearch() {
      this.fetchData({ search: this.searchQuery, companyId: this.companyId });
    },
    async fetchData(query) {
      this.loading = true;
      try {
        await this.$store.dispatch("admin/fetchSales", query);
      } catch (error) {
        this.$message.error(error.message || error);
      } finally {
        this.loading = false;
      }
    },
    onPaginate(value) {
      if (value > 0 && value < this.sales.pages + 1) {
        this.currentPage = value;
        this.fetchData({
          search: this.searchQuery,
          page: this.currentPage,
          companyId: this.companyId,
        });
      }
    },
    // onCompanySelect(value) {
    //   this.companyId = value;
    //   this.$store.dispatch("admin/fetchSales", {
    //     companyId: value,
    //   });
    // },
    handleCompanyChange(value) {
      if (!value) {
        Object.assign(this, {
          company: {},
          companyId: null,
          fetchingCompanies: false,
        });
        return this.fetchData({ search: this.searchQuery });
      }
      const company = this.companies.find((item) => item.id === value);
      Object.assign(this, {
        company,
        companyId: value,
        fetchingCompanies: false,
      });

      return this.fetchData({ companyId: value, search: this.searchQuery });
    },

    async fetchCompanies(value) {
      this.fetchingCompanies = true;
      try {
        const {
          data: { rows },
        } = await http.get(`/companies?${value}`);
        this.companies = rows;
      } catch (error) {
        this.$message.error(error.message || error);
      } finally {
        this.fetchingCompanies = false;
      }
    },
  },
};
</script>

<style scoped>
.nav-item {
  cursor: pointer;
}

.nav-item .nav-link:hover {
  color: #8bc34a;
}

.jumbotron {
  overflow-x: scroll;
}
</style>
